const TokenKey = 'token';
const NewOrder = 'newOrderList';
const oldLogin = 'oldLogin';
export function getToken() {
	return sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
	return sessionStorage.setItem(TokenKey, token);
}
export function removeToken() {
	return sessionStorage.removeItem(TokenKey);
}

export function getNewOrder() {
	return sessionStorage.getItem(NewOrder);
}

export function setNewOrder(data) {
	return sessionStorage.setItem(NewOrder, data);
}
export function removeNewOrder() {
	return sessionStorage.removeItem(NewOrder);
}

export function getOldLogin() {
	return localStorage.getItem(oldLogin);
}

export function setOldLogin(data) {
	return localStorage.setItem(oldLogin, data);
}
export function removeOldLogin() {
	return localStorage.removeItem(oldLogin);
}


// WEBPACK FOOTER //
// ./src/utils/auth.js